import { render, staticRenderFns } from "./widgetTime.vue?vue&type=template&id=322e08e4&scoped=true"
import script from "./widgetTime.vue?vue&type=script&lang=js"
export * from "./widgetTime.vue?vue&type=script&lang=js"
import style0 from "./widgetTime.vue?vue&type=style&index=0&id=322e08e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322e08e4",
  null
  
)

export default component.exports